import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { pickCompressedImage, callAPI, showErrorToast, userErrorMessage } from 'helpers';
import { checkPictureFace } from 'validations.picture';

// Components
import { Link } from 'react-router-dom';

// Hooks
import { useSelector, useDispatch } from 'react-redux';

// Data
import programMap from 'data/programs.json';

const SectionApplicantInfo = () => {
  const dispatch = useDispatch();
  const profile = useSelector((state) => _.get(state, 'app.user') || {});

  const uploadable = true;
  const [uploading, setUploading] = useState(false);
  const onUpload = async (e) => {
    if (uploading) return true;
    setUploading(true);
    const file = await pickCompressedImage(e);
    if (!file) {
      setUploading(false);
      return;
    }
    try {
      const faceError = await checkPictureFace(file);
      if (faceError) {
        showErrorToast(faceError);
        setUploading(false);
        return;
      }

      const formData = new FormData();
      formData.append('picture', file);

      const { picture } = await callAPI({
        method: 'PUT',
        url: '/applicants/me/pictures',
        formData,
      });
      setUploading(false);
      dispatch({
        type: 'UPDATE_USER',
        result: { ...profile, picture },
      });
    } catch (error) {
      setUploading(false);
      // ข้อความของ server (ล็อกแก้ไข / รูปไม่ผ่านตรวจใบหน้า ฯลฯ) — เดิมหยุด spinner เงียบๆ
      showErrorToast(userErrorMessage(error, 'อัปโหลดรูปไม่สำเร็จ กรุณาลองใหม่อีกครั้ง'));
    }
  };

  useEffect(() => {
    const classNames = document.getElementById('root').className.split(' ');
    if (uploading) {
      document.getElementById('root').className = _.uniq(classNames.concat(['is-loading'])).join(' ');
    } else {
      document.getElementById('root').className = classNames.filter((name) => name !== 'is-loading').join(' ');
    }
  }, [uploading]);

  return (
    <div className="t-box">
      {(uploading) && <div className="t-loading" />}
      <h2 className="title">
        {'ข้อมูลการลงทะเบียน'}
        <Link to="/profile/applicant-info" className="_border_0">{'รายละเอียด'} →</Link>
      </h2>
      <table>
        <tbody>
          <tr>
            {uploadable && (
              <td className="align-middle" width="140">
                {profile.picture ? (
                  <img
                    alt="Student"
                    src={profile.picture}
                    width="120"
                    className="img-rounded aspect-[4/5] object-cover" />
                ) : (
                  <span className="pic-upload cursor-pointer">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M11.9854 2.99998C11.7252 3.00387 11.4769 3.10896 11.293 3.29295L8.29297 6.29295C8.19699 6.3851 8.12037 6.49546 8.06758 6.61759C8.0148 6.73972 7.98691 6.87115 7.98556 7.0042C7.9842 7.13724 8.00941 7.26921 8.0597 7.39239C8.10999 7.51557 8.18435 7.62747 8.27843 7.72155C8.37251 7.81563 8.48441 7.88999 8.60759 7.94028C8.73077 7.99057 8.86274 8.01578 8.99578 8.01442C9.12883 8.01307 9.26026 7.98518 9.38239 7.9324C9.50452 7.87961 9.61489 7.80299 9.70703 7.70701L11 6.41404V15.5C10.9981 15.6325 11.0226 15.7641 11.072 15.887C11.1214 16.01 11.1948 16.1219 11.2878 16.2163C11.3809 16.3107 11.4918 16.3856 11.614 16.4367C11.7363 16.4879 11.8675 16.5142 12 16.5142C12.1325 16.5142 12.2637 16.4879 12.386 16.4367C12.5082 16.3856 12.6191 16.3107 12.7122 16.2163C12.8052 16.1219 12.8786 16.01 12.928 15.887C12.9774 15.7641 13.0019 15.6325 13 15.5V6.41404L14.293 7.70701C14.3851 7.80299 14.4955 7.87961 14.6176 7.9324C14.7397 7.98518 14.8712 8.01307 15.0042 8.01442C15.1373 8.01578 15.2692 7.99057 15.3924 7.94028C15.5156 7.88999 15.6275 7.81563 15.7216 7.72155C15.8157 7.62747 15.89 7.51557 15.9403 7.39239C15.9906 7.26921 16.0158 7.13724 16.0144 7.0042C16.0131 6.87115 15.9852 6.73972 15.9324 6.61759C15.8796 6.49546 15.803 6.3851 15.707 6.29295L12.707 3.29295C12.6124 3.19833 12.4998 3.12365 12.3759 3.07332C12.2519 3.023 12.1191 2.99806 11.9854 2.99998ZM6 8.49998C4.35498 8.49998 3 9.85496 3 11.5V18C3 19.645 4.35498 21 6 21H18C19.645 21 21 19.645 21 18V11.5C21 9.85496 19.645 8.49998 18 8.49998H17.5C17.3675 8.49811 17.2359 8.52259 17.113 8.572C16.99 8.62142 16.8781 8.69478 16.7837 8.78782C16.6893 8.88087 16.6144 8.99174 16.5632 9.11399C16.5121 9.23625 16.4858 9.36746 16.4858 9.49998C16.4858 9.63251 16.5121 9.76371 16.5632 9.88597C16.6144 10.0082 16.6893 10.1191 16.7837 10.2121C16.8781 10.3052 16.99 10.3785 17.113 10.428C17.2359 10.4774 17.3675 10.5019 17.5 10.5H18C18.564 10.5 19 10.936 19 11.5V18C19 18.564 18.564 19 18 19H6C5.43602 19 5 18.564 5 18V11.5C5 10.936 5.43602 10.5 6 10.5H6.5C6.63251 10.5019 6.76407 10.4774 6.88704 10.428C7.01001 10.3785 7.12193 10.3052 7.2163 10.2121C7.31067 10.1191 7.38561 10.0082 7.43676 9.88597C7.4879 9.76371 7.51424 9.63251 7.51424 9.49998C7.51424 9.36746 7.4879 9.23625 7.43676 9.11399C7.38561 8.99174 7.31067 8.88087 7.2163 8.78782C7.12193 8.69478 7.01001 8.62142 6.88704 8.572C6.76407 8.52259 6.63251 8.49811 6.5 8.49998H6Z"
                        fill="currentColor"
                      ></path>
                    </svg>
                    <label>
                      {'อัปโหลดรูปถ่าย'}
                      <input type="file" accept="image/*" onChange={onUpload} />
                    </label>
                  </span>
                )}
              </td>
            )}
            <td className="align-middle _heading">
              <ul className="list-none m-0">
                <li>{'ชื่อ'} <b>{profile.first_name} {profile.last_name}</b></li>
                <li>{'โรงเรียน'} <b>{profile.school_name}</b></li>
                <li>{'จังหวัด'} <b>{profile.school_province_name}</b></li>
                <li>{'หลักสูตร'} <b>{programMap[profile.program_code]}</b></li>
                <li>{'ปีการศึกษา'} <b>{profile.school_year}</b></li>
                {Boolean(profile.special_request) && (
                  <li className="flex gap-1">
                    <i className="i-disability i-20"></i>
                    <b>{profile.special_request}</b>
                  </li>
                )}
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default SectionApplicantInfo;
